/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionAddDto { 
    amount: number;
    currency: TransactionAddDto.CurrencyEnum;
    transactionDate: string;
    description: string;
    paymentAccountId: number;
    invoiceId?: number;
    exchangeRateFromBaseToCurrency?: number;
}
export namespace TransactionAddDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


